// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"49351dd7","109":"37754076","341":"c1673f71","531":"49c7a0c8","818":"d0ea1bb1"}[chunkId] + ".css";
};